import { useEffect, useRef, useState } from "react";

import { PastGoalsProps } from "./types";
import { PastToggle } from "./styles";

export const PastGoals = ({
  count,
  isInitiallyOpen = false,
  isScrollTarget = false,
  children,
}: PastGoalsProps) => {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const hasScrolled = useRef(false);
  const hasGoals = count > 0;

  useEffect(() => {
    if (
      !isInitiallyOpen ||
      !isScrollTarget ||
      !hasGoals ||
      hasScrolled.current
    ) {
      return;
    }
    hasScrolled.current = true;
    toggleRef.current?.scrollIntoView?.({ block: "center" });
  }, [isInitiallyOpen, isScrollTarget, hasGoals]);

  if (!hasGoals) {
    return null;
  }

  return (
    <>
      <PastToggle
        ref={toggleRef}
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        Past goals ({count})
      </PastToggle>
      {isOpen && children}
    </>
  );
};
